import APIService from '../api';
import { IBusinessReferral } from '@/models/marketingCenter/referral';

export default class ReferralService extends APIService {
  getReferral() {
    return this.get('/admin/business-referral');
  }

  createReferral(data: IBusinessReferral) {
    return this.post('/admin/business-referral', data);
  }

  updateReferral(id: number | string, data: IBusinessReferral) {
    return this.put(`/admin/business-referral/${id}`, data);
  }

  changeStatus(id: number | string) {
    return this.put(`/admin/business-referral/status/${id}`);
  }

  async getChart(id: number | string) {
    return this.get(`/admin/business-referral/graph/${id}`);
  }
}
